// extracted by mini-css-extract-plugin
export default {"textPages":"text_textPages__tLZBh"};